import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import DocumentationSvg from '../../../assets/icons/nav/documentation.svg?raw';

export const DocumentationIcon = (props) => <CustomSVG svg={DocumentationSvg} preserveColors {...props} />;
